<template>
  <div class="bg_fff">
    <div class="flex videoDetails__head_row">
      <div>日常养生如何吃的放心</div>
      <div class="col_666 flex_center articleList__browse"><span class="iconfont icon-liulan"></span><span>2343</span></div>
    </div>
    <div class="articleDetails__content">
      <img src="/static/img/itemList_img1.png" alt="">
      图文详情图文详情图文详情图文详情
    </div>
  </div>
</template>

<script>
  export default {
    name: "articleDetails"
  }
</script>

<style scoped>
  .videoDetails__head_row{
    padding: 0 .75rem;
    font-size: .75rem;
    color: #333;
    min-height: 2.5rem;
  }
  .articleList__browse{
    justify-content: end;
    -webkit-justify-content: flex-end;
    font-size: .6rem;
    height: .6rem;
    line-height: .6rem;
  }
  .articleDetails__content{
    font-size: .7rem;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/message/articleDetails.vue